import React, { useState } from "react";
import classes from "./Signin.module.css";
import bigcirlce from "../../Assets/bigcircle.svg";
import smallcirlce from "../../Assets/smallcircle.svg";
import promix from "../../Assets/Promix.svg";
import cal from "../../Assets/calculate.svg";
import accend from "../../Assets/accend.svg";
import corporate from "../../Assets/corporate.svg";
import smallsquare from "../../Assets/smallsquare.svg";
import bigsquare from "../../Assets/bigsquare.svg";
import eye from "../../Assets/eye.svg";
import eyesoff from "../../Assets/eyesoff.svg"
import { Link } from "react-router";
import api, { BASE_URL } from '../../Components/API/Api';
import Swal from "sweetalert2";
import { useUser } from '../../UserContext';
import { useNavigate } from "react-router-dom";


const Signin = () => {
  const { login, setActiveCompany } = useUser();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [showCompanySelector, setShowCompanySelector] = useState(false);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();


  const handleLogin = async () => {
    if (!email || !password) {
      Swal.fire('Error', 'Email and password are required', 'error');
      return;
    }

    setLoading(true);

    try {
      const response = await api.post('/v1/login', { email, password });

      const token = response.data?.data?.token;

      console.log('API Response:', response.data);

      const userData = {
        name: response.data?.data?.name || 'User',
        email: email
      };

      if (response.data?.data?.user) {
        Object.assign(userData, response.data.data.user);
      }

      console.log('Extracted user data:', userData);

      if (!token) {
        throw new Error("Token not returned from server.");
      }

      // Save token and user immediately so other requests can run
      login(userData, token);
      // Fetch companies available to this user
        try {
        const compRes = await api.get(`/v1/companies/get-info`);
        const list = Array.isArray(compRes?.data?.data) ? compRes.data.data : (compRes?.data?.data ? [compRes.data.data] : []);
        setCompanies(list);
        try { localStorage.setItem('companies', JSON.stringify(list)); } catch (e) { console.error('Failed to persist companies', e); }

        if (list.length === 0) {
          // No company found — proceed to dashboard
          setTimeout(() => { window.location.href = "/dashboard"; }, 300);
        } else if (list.length === 1) {
          // Single company — store and continue
          const item = list[0];
          const cid = item?.company_id || item?.id || item?.companyId || null;
          if (cid && typeof setActiveCompany === 'function') {
            setActiveCompany(cid, item);
          } else {
            if (cid) localStorage.setItem('company_id', String(cid));
            localStorage.setItem('companyInfo', JSON.stringify(item));
          }
          setTimeout(() => { window.location.href = "/dashboard"; }, 300);
        } else {
          // Multiple companies — let user pick
          setShowCompanySelector(true);
        }
      } catch (e) {
        console.error('Failed to fetch companies after login', e);
        // proceed to dashboard anyway
        setTimeout(() => { window.location.href = "/dashboard"; }, 300);
      }

    } catch (error) {
      console.error('Login error:', error);
      console.error('Error response:', error.response?.data);

      // ❌ Error alert
      Swal.fire({
        title: 'Login Failed',
        text: error.response?.data?.message || error.message,
        icon: 'error',
        confirmButtonText: 'Try Again'
      });

    } finally {
      setLoading(false);
    }
  };


  return (
    <div>
      <div className={classes.main}>
        <div className={classes.leftside}>
          <img src={bigcirlce} className={classes.paint} />
          <img src={smallcirlce} className={classes.point} />

          <div className={classes.grit}>
            <img src={promix} className={classes.pro} />
            <p className={classes.fir_txt}>
              Smart Accounting for Nigerian Businesses
            </p>
            <p className={classes.sec_txt}>
              Streamline your finances with AI-powered tools designed
              specifically for SMEs in Nigeria
            </p>

            <div className={classes.joptd}>
              <div>
                <img src={cal} />
              </div>
              <div>
                <p className={classes.cro_pt}>Complete Accounting Suite</p>
                <p className={classes.mind}>
                  Everything you need to manage your finances
                </p>
              </div>
            </div>
            <div className={classes.joptd}>
              <div>
                <img src={accend} />
              </div>
              <div>
                <p className={classes.cro_pt}>Growth Analytics</p>
                <p className={classes.mind}>
                  Track your business growth with detailed reports
                </p>
              </div>
            </div>
            <div className={classes.joptd}>
              <div>
                <img src={corporate} />
              </div>
              <div>
                <p className={classes.cro_pt}>Team Collaboration</p>
                <p className={classes.mind}>
                  Work together with your team seamlessly
                </p>
              </div>
            </div>

            <div className={classes.mvt}>
              <button className={classes.pthd}>View Features</button>
              <button className={classes.simp}>Contact Sales</button>
            </div>
            <img src={smallsquare} className={classes.bi_squ} />
            <img src={bigsquare} className={classes.sm_squ} />
          </div>
        </div>

        <div className={classes.right}>
          <div className={classes.protw}>
            <p className={classes.cre_top}>Welcome Back</p>
            <p className={classes.adkt}>Sign in to your account to </p>
          </div>

          <div className={classes.portned} onKeyDown={(e) => e.key === "Enter" && handleLogin()}>
            <div className={classes.coprte}>
              <label>Email Address</label>
              <input
                type="text"
                placeholder="Enter your email"
                className={classes.print}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className={classes.james}>
              <label>Password</label>
              <div className={classes.portal}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Create a strong password"
                  className={classes.print}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <img
                  src={showPassword ? eyesoff : eye}
                  alt="Toggle visibility"
                  className={classes.eye}
                  onClick={() => setShowPassword((prev) => !prev)}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            </div>

          </div>

          {showCompanySelector && (
            <div className={classes.companySelectWrap}>
              <label className={classes.companySelectLabel}>Select company to continue</label>
              <select
                value={selectedCompanyId}
                onChange={(e) => setSelectedCompanyId(e.target.value)}
                className={classes.companySelect}
              >
                <option value="">Choose company...</option>
                {companies.map((c, idx) => {
                  const id = c?.company_id || c?.id || c?.companyId || idx;
                  return (
                    <option key={id} value={id}>
                      {c?.name || c?.company_name || `Company ${idx + 1}`}
                    </option>
                  );
                })}
              </select>
              <div style={{ marginTop: 12 }}>
                <button
                  className={classes.sign}
                  onClick={() => {
                    if (!selectedCompanyId) {
                      return Swal.fire('Select company', 'Please select a company to continue', 'warning');
                    }
                    const sel = companies.find((c) => String(c?.company_id || c?.id || c?.companyId) === String(selectedCompanyId));
                    if (sel && typeof setActiveCompany === 'function') {
                      setActiveCompany(selectedCompanyId, sel);
                    } else {
                      if (sel) localStorage.setItem('companyInfo', JSON.stringify(sel));
                      localStorage.setItem('company_id', String(selectedCompanyId));
                    }
                    window.location.href = '/dashboard';
                  }}
                >
                  Continue
                </button>
              </div>
            </div>
          )}

          <div className={classes.joshe}>
            <div className={classes.pintoe}>
              <input type="checkbox" className={classes.shipet} />
              <p className={classes.abode}>Remember me</p>
            </div>

            <div>
              <p
                className={classes.crit}
                onClick={() => navigate("/forgotpassword")}
                style={{ cursor: "pointer" }}
              >
                Forgot password?
              </p>
            </div>
          </div>

          <button
            className={classes.sign}
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? (
              <span className={classes.spinner}></span>  // Spinner here
            ) : (
              'Sign in'
            )}
          </button>


          <p className={classes.rec}>
            Don't have an account?{" "}
            <Link to="/signup">
              <span className={classes.cptue}>Sign up</span>
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Signin;
